import { render, staticRenderFns } from "./product_detail.vue?vue&type=template&id=3718f276&scoped=true&"
import script from "./product_detail.vue?vue&type=script&lang=js&"
export * from "./product_detail.vue?vue&type=script&lang=js&"
import style0 from "./product_detail.vue?vue&type=style&index=0&id=3718f276&lang=less&scoped=true&"
import style1 from "./product_detail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3718f276",
  null
  
)

export default component.exports